import React, { useState } from "react";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    setSuccess(false);

    setTimeout(() => {
      setSuccess(true);
      setLoading(false);

      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    }, 800);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-gradient-to-br from-gray-100 via-gray-200 to-gray-100 relative overflow-hidden">

      {/* SOFT BLOBS */}
      <div className="absolute w-[400px] h-[400px] bg-red-300 blur-3xl rounded-full top-[-100px] left-[-100px] opacity-20"></div>
      <div className="absolute w-[400px] h-[400px] bg-blue-300 blur-3xl rounded-full bottom-[-100px] right-[-100px] opacity-20"></div>

      {/* CARD */}
      <div className="relative w-full max-w-6xl grid md:grid-cols-2 rounded-3xl overflow-hidden shadow-xl bg-white">

        {/* LEFT SIDE */}
        <div className="p-12 bg-gradient-to-br from-gray-800 to-gray-700 text-white flex flex-col justify-center">

          <h2 className="text-4xl font-bold leading-tight">
            Let’s Build Something <span className="text-red-400">Great</span>
          </h2>

          <p className="mt-4 text-gray-300">
            We create modern websites, apps and digital solutions that help businesses grow faster.
          </p>

          <div className="mt-10 space-y-3 text-sm text-gray-300">
            <p>📍 Ludhiana, Punjab</p>
            <p>📞 +91 78149 55755</p>
            <p>📧 info@securewebhosting.co.in</p>
          </div>

        </div>

        {/* RIGHT FORM */}
        <div className="p-12">

          <h2 className="text-2xl font-bold text-gray-900">
            Contact Us
          </h2>

          <p className="text-gray-500 text-sm mt-1">
            We usually respond within 24 hours
          </p>

          {success && (
            <div className="mt-4 p-3 bg-green-100 text-green-700 rounded-lg text-sm">
              ✅ Message saved successfully!
            </div>
          )}

          <form onSubmit={handleSubmit} className="mt-8 space-y-5">

            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-400 outline-none"
              required
            />

            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your Email"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-400 outline-none"
              required
            />

            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="Phone Number"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-400 outline-none"
            />

            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows="4"
              placeholder="Your Message"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-400 outline-none"
              required
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl font-semibold transition shadow-md hover:shadow-lg"
            >
              {loading ? "Sending..." : "Send Message →"}
            </button>

          </form>

        </div>

      </div>
    </div>
  );
};

export default Contact;